// Normalise a "share" URL from Loom / YouTube into an embed-ready URL. If the
// URL is already an embed URL or a direct .mp4, it's returned as-is.
//
// Supported patterns:
//   • https://www.loom.com/share/<id>              → https://www.loom.com/embed/<id>
//   • https://loom.com/share/<id>?...              → https://www.loom.com/embed/<id>
//   • https://www.loom.com/embed/<id>              → passthrough
//   • https://youtu.be/<id>                        → https://www.youtube.com/embed/<id>?...
//   • https://www.youtube.com/watch?v=<id>&t=5     → https://www.youtube.com/embed/<id>?start=5
//   • https://www.youtube.com/embed/<id>           → passthrough
//   • Anything ending in .mp4                      → passthrough (rendered <video>)
//
// Returns `{ kind: "iframe" | "video" | null, src: string | null }`.
export function embedForUrl(rawUrl) {
  if (!rawUrl) return { kind: null, src: null };
  let url;
  try {
    url = new URL(rawUrl);
  } catch {
    return { kind: null, src: null };
  }
  const host = url.host.replace(/^www\./, "");

  // Direct video file
  if (/\.mp4(\?|$)/i.test(url.pathname + url.search)) {
    return { kind: "video", src: rawUrl };
  }

  // Loom
  if (host === "loom.com") {
    const m = url.pathname.match(/^\/(share|embed)\/([A-Za-z0-9-]+)/);
    if (m) return { kind: "iframe", src: `https://www.loom.com/embed/${m[2]}?hide_owner=true&hide_share=true` };
  }

  // YouTube
  if (host === "youtu.be") {
    const id = url.pathname.slice(1);
    if (id) {
      const start = url.searchParams.get("t");
      const s = start ? `?start=${parseInt(start, 10) || 0}` : "";
      return { kind: "iframe", src: `https://www.youtube.com/embed/${id}${s}` };
    }
  }
  if (host === "youtube.com") {
    if (url.pathname === "/watch") {
      const id = url.searchParams.get("v");
      if (id) {
        const t = url.searchParams.get("t");
        const s = t ? `?start=${parseInt(t, 10) || 0}` : "";
        return { kind: "iframe", src: `https://www.youtube.com/embed/${id}${s}` };
      }
    }
    if (url.pathname.startsWith("/embed/")) {
      return { kind: "iframe", src: rawUrl };
    }
  }

  // Fallback: assume it's already an embeddable iframe URL if it's https
  if (url.protocol === "https:") return { kind: "iframe", src: rawUrl };
  return { kind: null, src: null };
}
